import React from 'react';
import classnames from 'classnames';
import { LightBackground } from 'scy/Background';
import { TextButton } from 'scy/buttons';
import { secondary } from 'scy/text/styles.mod.scss';
import { flex, flex1, centerItems } from 'scy/flex.mod.scss';
import { textRight } from 'scy/utils.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function CheckoutSection({
  isExpanded,
  collapse,
  expand,
  canEdit,
  Collapsed,
  Expanded,
  alignTop
}) {
  return (
    <LightBackground tag="section" className={styles.section}>
      {isExpanded ? (
        <Expanded collapse={collapse} />
      ) : (
        <div
          className={classnames(flex, {
            [centerItems]: !alignTop
          })}
        >
          <Collapsed expand={expand} canEdit={canEdit} />
          {canEdit && (
            <div className={`${flex1} ${secondary} ${textRight}`}>
              <TextButton
                className={classnames(margin.left_xs, {
                  [`${padding.left_xs} ${padding.right_xs}`]: alignTop,
                  [padding.xs]: !alignTop
                })}
                noUnderline
                onClick={expand}
              >
                Edit
              </TextButton>
            </div>
          )}
        </div>
      )}
    </LightBackground>
  );
}
